import { apiConfig } from "./client";

export const reportApi = {
  order: async <T>(from: number, to: number, signal?: AbortSignal) => {
    const response = await apiConfig.get<T>(
      `/api/front/chef/report/sale/${from}/${to}`,
      { signal }
    );
    return response;
  },
  penalty: async <T>(from: number, to: number, signal?: AbortSignal) => {
    const response = await apiConfig.get<T>(
      `/api/front/chef/report/penalty/${from}/${to}`,
      { signal }
    );
    return response;
  },
  archive: async <T>(from: number, to: number, signal?: AbortSignal) => {
    const response = await apiConfig.get<T>(
      `/api/front/chef/report/order/${from}/${to}`,
      { signal }
    );
    return response;
  },
  score: async <T>(from: number, to: number, signal?: AbortSignal) => {
    const response = await apiConfig.get<T>(
      `/api/front/chef/report/Score/${from}/${to}`,
      { signal }
    );
    return response;
  },
};
